import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { hasAdminRole } from "@/lib/auth-roles"
import { PersonaAccessBlocked, personaAccessQueryOptions } from "@/components/agents/persona/personaAccess"
import { NavigationHeader } from "@/components/e2e/layout/NavigationHeader"
import { queryClient } from "../../../query-client"
import { meQueryOptions } from "../../../me"

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/**
 * $picId = PIC PHỤ TRÁCH LEAD (giống /e2e/$userId). PIC không phải quản trị luôn ở trang của
 * mình và thấy lượt mình giao HOẶC trên lead mình phụ trách; quản trị chọn PIC bất kỳ, "all" =
 * tất cả. Người giao việc lọc riêng trong danh sách. Server khoanh lại (lib/persona-scope).
 *
 * Sale newbie chưa được vào trang (lib/persona-access) — hiện lời giải thích thay vì
 * đẩy đi chỗ khác; quản trị vẫn mở trang của PIC newbie để làm thay.
 */
export const Route = createFileRoute("/persona-management/$picId")({
  beforeLoad: async ({ params, location }) => {
    const user = await queryClient.ensureQueryData(meQueryOptions)
    if (!user) throw redirect({ href: "/" })

    const admin = hasAdminRole(user.role)
    const allowed = params.picId === user.id
      || (admin && (params.picId === "all" || UUID.test(params.picId)))
    if (!allowed) {
      const own = admin ? "all" : user.id
      const rest = location.pathname.split("/").slice(3).join("/")
      throw redirect({
        href: `/persona-management/${own}${rest ? `/${rest}` : ""}${location.searchStr ?? ""}`,
        replace: true,
      })
    }
    if (admin) return { personaBlocked: null }
    const access = await queryClient.ensureQueryData(personaAccessQueryOptions)
    return { personaBlocked: access.allowed ? null : access.reason ?? "Trang Cố vấn chưa mở cho bạn." }
  },
  component: PersonaGate,
})

function PersonaGate() {
  const { personaBlocked } = Route.useRouteContext()
  if (!personaBlocked) return <Outlet />
  return (
    <div className="min-h-screen bg-background">
      <NavigationHeader currentPage="persona" />
      <PersonaAccessBlocked reason={personaBlocked} />
    </div>
  )
}
